import { X, Crown } from "lucide-react";
import type { Session } from "@supabase/supabase-js";
import type { Language } from "../data";

type TFunc = (key: string) => string;

export function SubscriptionPage({ dir, onSelectPlan, onContinueFree, onBack }: {
  t: TFunc;
  dir: "rtl" | "ltr";
  lang: Language;
  session: Session | null;
  onSelectPlan: () => void;
  onContinueFree: () => void;
  onBack: () => void;
}) {
  if (!true) return null;
  const isAr = dir === "rtl";

  const plans = [
    { id: "monthly", name: isAr ? "اشتراك شهري" : "Monthly", price: isAr ? "٩٫٩٩ $" : "$9.99", period: isAr ? "/شهر" : "/mo" },
    { id: "yearly", name: isAr ? "اشتراك سنوي" : "Yearly", price: isAr ? "٤٩٫٩٩ $" : "$49.99", period: isAr ? "/سنة" : "/yr", badge: isAr ? "وفّر ٥٨٪" : "Save 58%" },
  ];

  return (
    <div dir={dir} className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onBack}>
      <div className="w-full max-w-md bg-white dark:bg-slate-900 rounded-3xl shadow-2xl overflow-hidden" onClick={e => e.stopPropagation()}>
        <div className="bg-gradient-to-br from-[#0A2240] to-[#0E3360] px-5 py-5 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Crown className="w-5 h-5 text-[#F5D98A]" />
            <h2 className="text-white font-bold text-lg">{isAr ? "الاشتراك المميز" : "Premium subscription"}</h2>
          </div>
          <button onClick={onBack} className="w-8 h-8 rounded-full bg-white/15 hover:bg-white/25 flex items-center justify-center text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="p-5 space-y-3">
          {plans.map(plan => (
            <button
              key={plan.id}
              onClick={onSelectPlan}
              className="w-full p-4 rounded-2xl border-2 border-stone-200 dark:border-slate-700 hover:border-blue-500 transition-all text-start flex items-center justify-between"
            >
              <div>
                <p className="font-bold text-stone-800 dark:text-slate-200">{plan.name}</p>
                <p className="text-sm text-stone-500 dark:text-slate-400">{plan.price}<span className="text-xs">{plan.period}</span></p>
              </div>
              {plan.badge && (
                <span className="px-2 py-1 rounded-full bg-green-100 dark:bg-green-500/20 text-green-600 dark:text-green-400 text-xs font-bold">{plan.badge}</span>
              )}
            </button>
          ))}
          <button
            onClick={onContinueFree}
            className="w-full py-3 rounded-xl text-stone-500 dark:text-slate-400 font-medium text-sm hover:bg-stone-50 dark:hover:bg-slate-800 transition-colors"
          >
            {isAr ? "متابعة بالإصدار المجاني" : "Continue with free version"}
          </button>
        </div>
      </div>
    </div>
  );
}
